import { createAction } from '@reduxjs/toolkit'

/**
 * Actions do módulo Admin
 */
export const adminActions = {
  // Pending orders count
  fetchPendingOrdersCountRequest: createAction('admin/fetchPendingOrdersCountRequest'),
  fetchPendingOrdersCountSuccess: createAction<{ count: number }>('admin/fetchPendingOrdersCountSuccess'),
  fetchPendingOrdersCountFailure: createAction<{ error: string }>('admin/fetchPendingOrdersCountFailure'),
  
  // Dashboard stats (para expansão futura)
  fetchDashboardStatsRequest: createAction('admin/fetchDashboardStatsRequest'),
  fetchDashboardStatsSuccess: createAction<any>('admin/fetchDashboardStatsSuccess'),
  fetchDashboardStatsFailure: createAction<{ error: string }>('admin/fetchDashboardStatsFailure'),
  
  // Clear errors
  clearPendingCountError: createAction('admin/clearPendingCountError'),
  clearDashboardError: createAction('admin/clearDashboardError'),
}

